<template>
  <div>
    <iframe id="iframePaq" src="https://allseasons.tourvector.com/espanol/listado/"></iframe>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapActions } from "vuex"
import { mapGetters } from "vuex"
import iFrameResize from "iframe-resizer/js/iframeResizer"

export default {
  name: "ebooking",
  components: {},
  mounted() {
    iFrameResize({ log: true }, "#iframePaq")
  },
  beforeCreate() {},
  methods: {
    ...mapActions("carrito", {
      limpiarCarrito: "limpiar"
    }),
    init() {
      this.limpiarCarrito()
      this.limpiarCarrito()
      this.setApp()
      this.$store.dispatch("app/setFormSave", null)
      this.$store.dispatch("app/setFormSaveTicket", null)
    },
    setApp() {
      this.$store.dispatch("app/saveApp", this.$route.meta.app)
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.init()
    })
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters("app", {
      app: "getApp"
    })
  }
}
</script>
<style>
#iframePaq {
  border: 0;
  width: 100%;
  height: 500px;
}
</style>
